import React from "react";
import { Modal } from "react-bootstrap";

const ModalLayoutWithDelete = ({
  deleteModalShow,
  closeDeleteDialog,
  title,
  deleteEntity,
  idForDelete,
}) => {
  return (
    <Modal
      show={deleteModalShow}
      onHide={closeDeleteDialog}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {<span>Are you sure to permanently delete this {title} ?</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={closeDeleteDialog}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={() => deleteEntity(idForDelete)}
            className="btn btn-delete btn-elevate"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalLayoutWithDelete;
